var React = require('react');

function SimpleLogoInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"logo"),React.createElement("path",{"d":"M56.94,53h0L98.34,3.6a14.31,14.31,0,0,0-20.2,1.8l-15,17.8A32.78,32.78,0,0,0,52.94,7.5a32.23,32.23,0,1,0,4,45.5M18.54,20.7A17.89,17.89,0,1,1,46,43.6h0a18.1,18.1,0,0,1-25.2,2.3,17.73,17.73,0,0,1-2.3-25.2","key":1}),React.createElement("path",{"d":"M113.24,58.2a32.29,32.29,0,0,0-45.4,3.9h0l-41.4,49.3a14.31,14.31,0,0,0,20.2-1.8l15-17.8a32.78,32.78,0,0,0,10.2,15.7,32.19,32.19,0,1,0,41.4-49.3m-6.9,36.2A17.89,17.89,0,1,1,104,69.2a17.91,17.91,0,0,1,2.3,25.2","key":2})]);
}

SimpleLogoInline.defaultProps = {"viewBox":"0 0 124.78 115.04","fill":"#f6f6f6"};

module.exports = SimpleLogoInline;

SimpleLogoInline.default = SimpleLogoInline;
